import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SparklesTextComponent } from './sparkles-text.component';

@NgModule({
    declarations: [
        SparklesTextComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        SparklesTextComponent
    ]
})
export class NcSparklesTextModule { }